<div class="back-button back-button--{{ view }}">
  <div class="back-button__container">
    <img
      class="back-button__icon back-button__icon--desktop"
      mfpLazyImage
      lazySrc="assets/icons/back-arrow-desktop.svg"
      alt="Back button icon"
      [ngClass]="{ 'add-button__icon--no-margin': !label }"
      (click)="onClickArrow()"
    />
    <img
      class="back-button__icon back-button__icon--mobile"
      mfpLazyImage
      lazySrc="assets/icons/back-arrow-mobile.svg"
      alt="Back button icon"
      [ngClass]="{ 'add-button__icon--no-margin': !label }"
      (click)="onClickArrow()"
    />
    <ng-container *ngIf="label">
      <span class="back-button__label">{{ label }}</span>
    </ng-container>
  </div>
</div>
